import { useState, useEffect } from "react";
import { Church } from "../models/Church";
import { useUser } from "./useUser";
import { doc, onSnapshot } from "@firebase/firestore";
import { db } from "../firebase";

export type UseChurchReturn = {
  church: Church | undefined;
  loading: boolean;
  error: string;
};

export const useChurch = (churchId?: string): UseChurchReturn => {
  const [church, setChurch] = useState<Church>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>("");
  const user = useUser();

  useEffect(() => {
    if (churchId && user) {
      setLoading(true);
      setError('');

      return onSnapshot(
        doc(db, "churches", churchId),
        (snap) => {
          if (!snap.exists()) {
            setChurch(undefined);
            setError('Church not found. Check the link or ask for a new QR code.');
            setLoading(false);
            return;
          }
          const d = snap.data() as Church;
          setChurch({ ...d, id: snap.id });
          setLoading(false);
        },
        (err) => {
          setError(err.message);
          setLoading(false);
        }
      );
    } else {
      setChurch(undefined);
    }
  }, [churchId, user]);

  return {
    church,
    loading,
    error,
  };
};
